import React, { useState } from 'react'
import closeCard from '../../assets/img/close-responsive-card.svg'
import { getLocaleStringNumber, parseBudat } from '../utils/utils.js'

const PedidoHistorialResponsiveCard = (
  {
    pedido,
    getLitros,
    isDinamo,
    setSelectedPedido,
    setDisplayDetallePedido,
  }
) => {
  const [isClosed, setIsClosed] = useState(true)

  const litrosPedido = getLitros ? getLitros(pedido) : {}

  const openDetallePedido = () => {
    setSelectedPedido(pedido)
    setDisplayDetallePedido(true)
  }

  const toggleClosedCard = () => {
    setIsClosed(!isClosed)
  }

  const getTipoPedidoClass = () => {
    const tipoPedido = pedido.TIPO_PEDIDO ? pedido.TIPO_PEDIDO.toLowerCase() : ''

    if (tipoPedido.includes('emergencia')) {
      return 'eme'
    }

    if (tipoPedido.includes('preprograma')) {
      return 'pre'
    }

    if (tipoPedido.includes('cambio')) {
      return 'cam'
    }

    if (tipoPedido.includes('estandar') || tipoPedido.includes('estándar')) {
      return 'est'
    }

    return tipoPedido.substring(0, 3)
  }

  const getTipoPedidoSigla = () => {
    const tipoPedido = pedido.TIPO_PEDIDO ? pedido.TIPO_PEDIDO.toUpperCase() : ''

    if (tipoPedido.includes('EMERGENCIA')) {
      return 'EME'
    }

    if (tipoPedido.includes('PREPROGRAMA')) {
      return 'PRE'
    }

    if (tipoPedido.includes('CAMBIO')) {
      return 'CAM'
    }

    if (tipoPedido.includes('ESTANDAR') || tipoPedido.includes('ESTÁNDAR')) {
      return 'EST'
    }

    return tipoPedido.substring(0, 3)
  }

  return (
    <div className='pedido-historial-responsive-card-main-container'>
      <div className="pedido-historial-card-header">
        <div className="pedido-header-data">
          <div className="header-main-info" onClick={openDetallePedido}>
            <span className={`header-siglas ${getTipoPedidoClass()}`}>{getTipoPedidoSigla()} </span> N° de Pedido: <span className='header-pedido-nro'> {pedido.ID_PEDIDO}</span>
          </div>
          <div className="pedido-extra-info">
            <div className="historial-data-bloc mr-bloc">
              <div className="historial-data-label">
                Fecha Pref. de Entrega
              </div>
              <div className="historial-data-info">
                {parseBudat(pedido.FECHA_PREFERENTE_ENTREGA)}
              </div>
            </div>
            <div className="historial-data-bloc">
              <div className="historial-data-label">
                Volumen Entregado
              </div>
              <div className="historial-data-info">
                {getLocaleStringNumber(isDinamo ? litrosPedido.entregado : litrosPedido.litros)}
              </div>
            </div>
          </div>
        </div>
        <div className="pedido-header-close-container" onClick={toggleClosedCard}>
          <img src={closeCard} alt="" />
        </div>
      </div>
      
      <div className={`pedido-historial-card-separator ${isClosed ? 'closed' : ''}`}>
      </div>

      <div className={`pedido-historial-card-body ${isClosed ? 'closed' : ''}`}>
        <div className="pedido-body-data-container">
          <div className="historial-data-bloc mr-bloc">
            <div className="historial-data-label">
              Tipo de pedido
            </div>
            <div className="historial-data-info">
              {pedido.TIPO_PEDIDO}
            </div>
          </div>
          <div className="historial-data-bloc venta-solicitada-bloc">
            <div className="historial-data-label">
              Ventana Solicitada
            </div>
            <div className="historial-data-info">
              {pedido.HORARIO}
            </div>
          </div>
          <div className="historial-data-bloc mr-bloc">
            <div className="historial-data-label">
              Estado
            </div>
            <div className="historial-data-info">
              {pedido.ESTADO}
            </div>
          </div>
          <div className="historial-data-bloc">
            <div className="historial-data-label">
              Planta
            </div>
            <div className="historial-data-info">
              {pedido.PLANTA}
            </div>
          </div>
          <div className="historial-data-bloc mr-bloc">
            <div className="historial-data-label">
              Fecha Pref. de Entrega
            </div>
            <div className="historial-data-info">
              {parseBudat(pedido.FECHA_PREFERENTE_ENTREGA)}
            </div>
          </div>
          <div className="historial-data-bloc">
            <div className="historial-data-label">
              Volumen Planificado (L)
            </div>
            <div className="historial-data-info">
              {getLocaleStringNumber(isDinamo ? litrosPedido.planificado : pedido.VOLUMEN_PLANIFICADO)}
            </div>
          </div>
        </div>
      </div>

    </div>
  )
}

export default PedidoHistorialResponsiveCard